import { render, staticRenderFns } from "./BackLevel.vue?vue&type=template&id=3f67cfb2&scoped=true"
import script from "./BackLevel.vue?vue&type=script&lang=js"
export * from "./BackLevel.vue?vue&type=script&lang=js"
import style0 from "./BackLevel.vue?vue&type=style&index=0&id=3f67cfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67cfb2",
  null
  
)

export default component.exports